import { bonusesDTO } from './bonusesDTO';

import type { OrderBonuses } from './types';

export const bonusesOrDefaultDTO = (data: unknown): OrderBonuses => {
  if (!data || typeof data !== 'object') {
    return {
      cashback_identifier: null,
      bonuses_absolut: null,
      bonus_total: 0,
      fuelfree_bonuses_relative: 0,
      max_value: null,
      promotion_fixed: null,
      promotion_value: 0,
    };
  }

  return bonusesDTO(data);
};
